// @flow
import { get } from 'lodash';
import { CommonMapper } from 'mappers/common';
import { HomeActionTypes } from './actionTypes';

const getBannerData = () => (dispatch, getState, { api }) => {
  dispatch({
    type: HomeActionTypes.BANNER.FETCH,
    payload: {},
    test: api
      .post(`pageBanner.json`)
      .then(res => {
        dispatch({
          type: HomeActionTypes.BANNER.SUCCESS,
          payload: res.data,
        });
        return res;
      })
      .catch(error => {
        dispatch({
          type: HomeActionTypes.BANNER.FAILURE,
          error,
        });
      }),
  });
};
const getHeaderData = () => (dispatch, getState, { api }) => {
  dispatch({
    type: HomeActionTypes.HEADER.FETCH,
    payload: {},
    test: api
      .post(`getCustomLinks.json`)
      .then(res => {
        dispatch({
          type: HomeActionTypes.HEADER.SUCCESS,
          payload: res.data,
        });
        return res;
      })
      .catch(error => {
        dispatch({
          type: HomeActionTypes.HEADER.FAILURE,
          error,
        });
      }),
  });
};
const getContactDetails = () => (dispatch, getState, { api }) => {
  dispatch({
    type: HomeActionTypes.CONTACTS.FETCH,
    payload: {},
    test: api
      .post(`contactDetails.json`)
      .then(res => {
        const response = get(res, 'data.data', {});
        const mediaPath = CommonMapper.extractMediaPath(response);
        const contacts = response.contact_details || [];
        dispatch({
          type: HomeActionTypes.CONTACTS.SUCCESS,
          payload: CommonMapper.mapContacts(contacts, mediaPath),
        });
        return res;
      })
      .catch(error => {
        dispatch({
          type: HomeActionTypes.CONTACTS.FAILURE,
          error,
        });
      }),
  });
};

const getVerticals = () => (dispatch, getState, { api }) => {
  dispatch({
    type: HomeActionTypes.VERTICALS.FETCH,
    payload: {},
    test: api
      .post(`verticalList.json`)
      .then(res => {
        const response = get(res, 'data.data', {});
        const mediaPath = CommonMapper.extractMediaPath(response);
        const verticals = response.vertical_list || [];
        dispatch({
          type: HomeActionTypes.VERTICALS.SUCCESS,
          // payload: data,
          payload: CommonMapper.mapVerticals(verticals, mediaPath),
        });
        return res;
      })
      .catch(error => {
        dispatch({
          type: HomeActionTypes.VERTICALS.FAILURE,
          error,
        });
      }),
  });
};

const getSiteSettings = () => (dispatch, getState, { api }) => {
  dispatch({
    type: HomeActionTypes.SITE_SETTINGS.FETCH,
    payload: {},
    test: api
      .post(`siteSettings.json`)
      .then(res => {
        const response = get(res, 'data.result.data', {});
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: HomeActionTypes.SITE_SETTINGS.SUCCESS,
          payload: CommonMapper.mapSiteSettings(response, mediaPath),
        });
        return res;
      })
      .catch(error => {
        dispatch({
          type: HomeActionTypes.SITE_SETTINGS.FAILURE,
          error,
        });
      }),
  });
};

export const HomeActions = {
  getBannerData,
  getContactDetails,
  getVerticals,
  getSiteSettings,
  getHeaderData,
};
